import { Article } from '@/lib/types';

function normalize(value?: string) {
  return (value || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .replace(/[^\w\s-]/g, '');
}

export function dedupeArticles(
  articles: Article[]
): Article[] {
  if (!Array.isArray(articles)) return [];

  const seen = new Set<string>();

  return articles.filter((article) => {
    if (!article) return false;

    const fingerprint =
      normalize(article.slug) ||
      normalize(article.images?.[0]?.src) ||
      [
        normalize(article.headline),
        normalize(article.publishDate),
      ].join('|');

    if (!fingerprint) return false;

    if (seen.has(fingerprint)) {
      return false;
    }

    seen.add(fingerprint);

    return true;
  });
}